<template>
  <generic-modal
    size="large"
    :title="$t('account movement module configuration')"
    icon="settings"
    image="/images/icons/accounts.png"
    v-bind:scrolling="true"
    v-on:destroy="destroy"
    :show_ok="false"
    :show_cancel="false"
  >
    <div class="description">
      <movement-types />
    </div>
  </generic-modal>
</template>

<script>
import { local_api, stringify } from "@/utils";
import GenericModal from "@/components/GenericModal";
import MovementTypes from "./MovementTypes";

export default {
  components: {
    "generic-modal": GenericModal,
    MovementTypes
  },
  computed: {},
  data() {
    return {
      setup: {}
    };
  },
  methods: {
    destroy() {
      this.$emit("destroy");
      this.$destroy();
    }
  },
  mounted() {
    let vm = this;
    local_api(vm, "post", "/student_configuration/do-get-configuration")
      .then(conf => {
        vm.setup = conf;
      })
      .catch(err => {
        vm.$alertify.error(stringify(err));
      });

    window.jQuery(".ui.menu .item").tab();
  },
  watch: {},
  updated: function() {}
};
</script>
